import React, { Component } from "react";
import styled from "styled-components";
import { connect } from "react-redux";

import { doSetActiveChapterId } from "../redux/reducers";
import { Button } from "../base/Buttons";
import { colors } from "../themes/appTheme";

const ChapterTitle = styled.span`opacity: 0.65;`;

const ChapterTitleWrapper = styled.section`
  display: flex;
  justify-content: center;
  padding-top: ${props => props.theme.margins.sm};
  margin-top: ${props => props.theme.margins.md};
  border-top: 1px solid ${props => props.theme.colors.lightGrey};
`;

const Wrapper = styled.footer`
  display: flex;
  justify-content: ${props => {
    if (props.activePreviousChapter && props.activeNextChapter)
      return "space-between";
    if (props.activePreviousChapter && !props.activeNextChapter)
      return "flex-start";
    return "flex-end";
  }};
  align-items: center;
  margin-top: ${props => props.theme.margins.xl};
`;

class ChapterFooter extends Component {
  onPreviousChapterClick = () =>
    this.props.onChapterChange(this.props.previousChapterId);

  onNextChapterClick = () =>
    this.props.onChapterChange(this.props.nextChapterId);

  render() {
    const {
      titles,
      activeChapterId,
      previousChapterId,
      nextChapterId,
      totalChapters
    } = this.props;
    const activePreviousChapter = activeChapterId !== previousChapterId;
    const activeNextChapter = nextChapterId < totalChapters;
    const previousChapterTile = titles[previousChapterId];
    const nextChapterTitle = titles[nextChapterId];

    return (
      <div>
        <Wrapper
          activePreviousChapter={activePreviousChapter}
          activeNextChapter={activeNextChapter}
        >
          {activePreviousChapter && (
            <Button color={colors.purple} onClick={this.onPreviousChapterClick}>
              {"< " + previousChapterTile}
            </Button>
          )}

          {activeNextChapter && (
            <Button color={colors.purple} onClick={this.onNextChapterClick}>
              {`${nextChapterTitle}  >`}
            </Button>
          )}
        </Wrapper>

        <ChapterTitleWrapper>
          <ChapterTitle>{titles[activeChapterId]}</ChapterTitle>
        </ChapterTitleWrapper>
      </div>
    );
  }
}

const mapStateToProps = (state, { activeChapterId }) => ({
  totalChapters: state.book ? state.book.chapters.length : 0,
  nextChapterId:
    activeChapterId === activeChapterId.length - 1
      ? activeChapterId
      : activeChapterId + 1,
  previousChapterId: activeChapterId === 0 ? 0 : activeChapterId - 1
});

const mapDispatchToProps = dispatch => ({
  onChapterChange: chapterId => dispatch(doSetActiveChapterId(chapterId))
});

export default connect(mapStateToProps, mapDispatchToProps)(ChapterFooter);



// WEBPACK FOOTER //
// ./src/book/ChapterFooter.js